<template>
    <div class="budget">
        <el-card class="box-card">
            <div slot="header" class="text-left">
                <div class="row center-align-vert">
                    <div class="col-4 text-left">
                        <h4>Commercial</h4>
                    </div>
                    <div class="col-8 text-right">
                        <el-button class="date-editor-button-minus ml-10" @click="decreaseWeek">-</el-button>
                        <el-date-picker
                            v-model="date"
                            type="week"
                            format="Week WW-yyyy"
                            placeholder="Pick a week"
                            :picker-options=options
                            :clearable=false
                            @change="loadBudget">
                        </el-date-picker>
                        <el-button class="date-editor-button-plus" @click="increaseWeek">+</el-button>
                        <el-select class="ml-5-howrly" style="width: 125px;" v-model="level" @change="loadBudget">
                            <el-option
                                v-for="(value,key) in $store.state.budget.levels"
                                :disabled="getRoles.includes(String('10'+parseInt(value[0]))) === false"
                                :key="parseInt(key)"
                                :label="value"
                                :value="parseInt(key)">
                            </el-option>
                        </el-select>
                        <el-button class="ml-5-howrly" v-if="noBudgetsOpen === false && $store.state.budget.savedByUser === false" type="primary" plain @click="saveBudgetAndPrediction" :loading="saving" :disabled="saveButtonDisabled === true">Next</el-button>
                        <el-button class="ml-5-howrly" type="primary" disabled v-if="noBudgetsOpen === true" plain icon="el-icon-lock">Locked</el-button>
                        <el-button class="ml-5-howrly" v-if="$store.state.budget.savedByUser === true && budgetOpen()" type="warning" plain @click="setSavedFalse">Open budget</el-button>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center" v-if="savingError">
                <el-alert
                    title="Someting went wrong"
                    type="error"
                    center
                    description="Make sure all commercial variables and hours are positive numbers."
                    style="width: 800px;">
                </el-alert>
            </div>
            <el-table :data="$store.state.budget.predictionSums" row-key='id' @row-click="rowClicked" :row-class-name="tableRowClassName" ref="mainTable">
                <el-table-column
                    label='Variable'
                >
                    <template slot-scope="scope" v-if="scope.row">
                        {{scope.row.Variable | formatVariableName }}
                        <font-awesome-icon v-if="scope.row.Variable === 'Total hours'" size="1x" icon="info-circle" aria-hidden="true" v-b-popover.hover.right="infoModalContext()" variant="primary"/>
                    </template>
                </el-table-column>

                <el-table-column
                    v-for="col in tableHeaders"
                    :key="col"
                    :prop="col"
                    :label="col"
                    :formatter="formatter"
                >
                </el-table-column>
                <el-table-column
                    label='Adjusted'
                >
                    <template slot-scope="scope">
                        <template v-if="scope.row.Variable !== 'Total hours' && scope.row.Variable !== 'KPU' && scope.row.Variable !== 'CTR'">
                            <el-badge v-model="badgeValues[scope.row.Variable]" class="item" type="primary">
                                <el-input :id=scope.row.id :name="scope.row.Variable" v-validate.initial="'min_value:0'" :disabled="budgetOpen() === false || saveButtonDisabled === true || $store.state.budget.savedByUser === true" class="small-input vertical-align-center" @change="distributeChange($event, scope.row.Variable)" v-model="$store.state.budget.predictionSums.find(x => x.Variable === scope.row.Variable).Adjusted"></el-input>
                            </el-badge>
                        </template>
                        <template style="display: flex; and the align-items: center" v-if="scope.row.Variable === 'Total hours'">
                            <el-badge v-model="badgeValues[scope.row.Variable]" class="item" :type="hoursManuallyChanged === false ? 'primary' : 'info'">
                                <el-input :id=scope.row.id :name="scope.row.Variable" v-validate.initial="'min_value:0'" style="display: flex; and the align-items: center" :disabled="budgetOpen() === false || saveButtonDisabled === true || $store.state.budget.savedByUser === true" class="small-input vertical-align-center" @change="distributeChange($event, scope.row.Variable)" v-model="$store.state.budget.predictionSums.find(x => x.Variable === scope.row.Variable).Adjusted"></el-input>
                            </el-badge>
                        </template>
                        <template v-if="scope.row.Variable === 'KPU'">
                            <span>€{{scope.row.Adjusted.toLocaleString('en-EN', { maximumFractionDigits: 2 })}}</span>
                        </template>
                        <template v-if="scope.row.Variable === 'CTR'">
                            <span>{{scope.row.Adjusted.toLocaleString('en-EN', { maximumFractionDigits: 2 })}}%</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label='Actions'>
                    <template slot-scope="scope" v-if="scope.row.child === false">
                        <button @click.stop :disabled="budgetOpen() === false || saveButtonDisabled === true || $store.state.budget.savedByUser === true" @click="revertBudgetChange($event,scope.row.Variable)" type="button" class="btn btn-primary btn-circle"><font-awesome-icon size="1x" icon="undo"/></button>
                        <button @click.stop :disabled="budgetOpen() === false || saveButtonDisabled === true || $store.state.budget.savedByUser === true" @click="decrease($event,scope.row.Variable)" type="button" class="btn btn-circle btn-grey ml-5-howrly"><font-awesome-icon class="icon-button" size="1x" icon="minus-circle"/> </button>
                        <button @click.stop :disabled="budgetOpen() === false || saveButtonDisabled === true || $store.state.budget.savedByUser === true" @click="increase($event,scope.row.Variable)" type="button" class="btn btn-circle btn-grey ml-5-howrly"><font-awesome-icon class="icon-button" size="1x" icon="plus-circle"/> </button>
                        <button class="btn btn-circle btn-grey ml-5-howrly"  v-if="(errors.has(scope.row.Variable)) && saveButtonDisabled === false"> <i class="el-icon-warning" height="50px" width="50px"></i></button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import vue from 'vue'
import moment from 'moment'

function convertWeekToDate (week, year) {
    var d = null
    // TODO: FIX THIS
    if (parseInt(year) < 2021) {
        d = (1 + (week - 1) * 7) // 1st of January + 7 days for each week
    } else {
        d = (1 + (week) * 7)
    }
    return new Date(year, 0, d)
}

function getWeekNumber (d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
    // TODO: FIX THIS
    if (moment(yearStart).year() > 2020 && weekNo > 1) {
        weekNo -= 1
    }
    return [d.getUTCFullYear(), weekNo]
}

export default {
    props: ['saveButtonDisabled'],
    data () {
        return {
            options: { firstDayOfWeek: 1 },
            date: convertWeekToDate(this.$route.query.week, this.$route.query.year),
            level: parseInt(this.$route.query.level),
            saving: false,
            saved: false,
            tableHeaders: ['Last year', 'Predicted'],
            badgeValues: {},
            savingError: false,
            noBudgetsOpen: false
        }
    },

    computed: {
        hoursManuallyChanged () {
            // Computed property to check if there are manual changes to determine the color of the badge
            if (Object.values(this.$store.state.budget.manualTotalHourChange).length === 0) {
                return false
            }
            if (Math.abs(parseInt(Object.values(this.$store.state.budget.manualTotalHourChange).reduce((a, b) => a + b))) > 1) {
                return true
            } else {
                return false
            }
        },
        getRoles () {
            return localStorage.getItem('roles').split(',')
        }
    },

    methods: {
        setSavedFalse () {
            vue.set(this.$store.state.budget, 'savedByUser', false)
        },
        budgetOpen () {
            // If there is any underlying budget that is open, you can change this
            for (let b of this.$store.state.budget.budget) {
                if (b.budget_open === true) {
                    return true
                }
            }
            return false
        },
        infoModalContext () {
            // Function to get the context for each store that is displayed on hover over the information icon
            return {
                html: true,
                content: () => {
                    return 'Minimum hours: <em>' + this.$store.state.budget.budget.reduce(function (prev, cur) { return prev + cur.min_hours }, 0) + '</em><br>Stores: <em>' + this.$store.state.budget.budget.length + '</em><br>'
                }
            }
        },
        reopenBudget () {
            this.$emit('openBudget')
        },
        loadBudget () {
            this.$router.push({ name: 'budget-budget', query: { level: this.level, year: getWeekNumber(this.date)[0], week: getWeekNumber(this.date)[1] } })
            this.$emit('dateChanged')
        },
        saveBudgetAndPrediction () {
            // Function to save the budgets and predictions
            this.saving = true
            // Check whether there are errors in the input
            let error = false
            for (let v of this.$store.state.budget.predictionSums) {
                if (this.errors.has(v.Variable)) {
                    error = true
                }
            }
            if (error === false) {
                this.saving = false
                if (this.$store.state.budget.savingError === false) { // Check if saving in vuex went without errors
                    this.saved = true
                    this.$emit('saved')
                    document.getElementById('store-budgets').scrollIntoView({
                        behavior: 'smooth'
                    })
                    // Correct budgets that are under min hours
                    this.$store.dispatch('budget/correctMinimum').then(response => {
                        this.$store.commit('budget/SET_PREDICTION_SUMS') // Set the new sums now that minimum may have been corrected
                        this.updateBadgeValues() // Update the total hours badge in case hours has been corrected
                    })
                } else {
                    this.savingError = true
                    // eslint-disable-next-line
                    setTimeout(() => this.savingError = false, 5000)
                }
            } else {
                this.saving = false
                this.savingError = true
                // eslint-disable-next-line
                setTimeout(() => this.savingError = false, 5000)
            }
        },
        formatter (row, column) {
            // Formatter for the el-table
            if (row[column.property] !== undefined) {
                if (row['Variable'] === 'KPU' || row['Variable'].includes('revenue')) {
                    return '€' + row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 2 })
                } else if (row['Variable'] === 'CTR') {
                    return row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 2 }) + '%'
                } else {
                    return row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 2 })
                }
            }
        },

        distributeChange (value, name) {
            // This function is called when a commercial variable or the total hours is changed via the input fields
            if (name === 'Total hours') { // Total hours is directly changed
                let factor = value / this.$store.state.budget.predictionSums.find(x => x.Variable === name).Predicted
                this.$store.commit('budget/SET_MANUAL_HOUR_CHANGES', { 'factor': factor, 'updateHours': true, 'correctMinimum': false })
                this.$store.commit('budget/SET_PREDICTION_SUMS')
                this.updateBadgeValues()
            } else {
                // In this case we have changed a commercial variable and we need to recalculate the budget
                // Update prediction sums is done in the updatePredictionsFactor action
                let factor = value / this.$store.state.budget.predictionSums.find(x => x.Variable === name).Predicted
                this.$store.dispatch('budget/updatePredictionsFactor', { 'factor': factor, 'variable': name }).then(response => {
                    this.updateBadgeValues()
                })
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            if (row.Variable === 'Total hours') {
                return 'highlight-row'
            }
        },
        rowClicked (row) {
            var el = document.getElementById(row.id)
            if (el !== document.activeElement) {
                try {
                    this.$refs.mainTable.toggleRowExpansion(row)
                } catch (error) {
                    // Only expand parent rows
                }
            }
        },
        getValueBadge (variable) {
            // Get the impact of a commercial variable change on the budget using the regression model parameters
            // Loop over the predictions and calculate the hour change due to the change in this commercial variable
            let hoursDelta = 0
            for (let p of this.$store.state.budget.prediction) {
                let transforms = []
                let coefficients = []

                // Need to find buget for this prediction and get the regression params
                let b = this.$store.state.budget.budget.find(x => x.store_id === p.store_id)
                if (b !== undefined) {
                    let regressionSettings = b.regression_settings

                    for (let item of regressionSettings) {
                        if (item.var === variable) {
                            transforms.push(item.transform)
                            coefficients.push(item.factor)
                        }
                    }

                    for (let idx in transforms) {
                        hoursDelta += coefficients[idx] * Math.pow(p.dataload[variable], transforms[idx]) - coefficients[idx] * Math.pow(p.dataload_last_level[variable], transforms[idx])
                    }
                }
            }

            // Return the badge value with fallback for nan and inf
            if (hoursDelta === 0 || isNaN(hoursDelta) || isFinite(hoursDelta) === false) {
                return '0' + ' hours'
            } else if (hoursDelta > 1) {
                return '+' + String(Math.round(hoursDelta)) + ' hours'
            } else {
                return String(Math.round(hoursDelta)) + ' hours'
            }
        },
        revertBudgetChange (event, variable) {
            this.$store.dispatch('budget/revertBudgetChanges', variable).then(response => {
                this.updateBadgeValues()
            })
            // Remove the erorr message (apparently this only reacts to changes in the input field not underlying data)
            if (this.errors.has(variable)) {
                var idx = this.errors.items.indexOf(this.errors.items.find(x => x.field === variable))
            }
            this.errors.items.splice(idx, 1)
        },
        updateBadgeValues () {
            // Helper function to update all badges in this component
            for (let v of this.$store.state.budget.commercialBudgetVariables) {
                vue.set(this.badgeValues, v, this.getValueBadge(v))
            }
            let badgeValue = parseInt(this.$store.state.budget.predictionSums.find(x => x.Variable === 'Total hours').Adjusted - this.$store.state.budget.predictionSums.find(x => x.Variable === 'Total hours').Predicted)
            if (badgeValue > 0) {
                vue.set(this.badgeValues, 'Total hours', '+' + String(badgeValue) + ' hours')
            } else {
                vue.set(this.badgeValues, 'Total hours', String(badgeValue) + ' hours')
            }
        },
        increase (event, variable) {
            // Function that is called when someone presses the + button
            if (variable === 'Total hours') { // Total hours is directly changed
                let factor = (this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Adjusted / this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Predicted) * 1.02
                this.$store.commit('budget/SET_MANUAL_HOUR_CHANGES', { 'factor': factor, 'updateHours': true, 'correctMinimum': false })
                this.$store.commit('budget/SET_PREDICTION_SUMS')
                this.updateBadgeValues()
            } else { // In this case we have changed a commercial variable and we need to recalculate the budget
                let factor = (this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Adjusted / this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Predicted) * 1.02
                this.$store.dispatch('budget/updatePredictionsFactor', { 'factor': factor, 'variable': variable }).then(response => {
                    this.updateBadgeValues()
                })
            }
        },
        decrease (event, variable) {
            // Function that is called when someone presses the - button
            if (variable === 'Total hours') { // Total hours is directly changed
                let factor = (this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Adjusted / this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Predicted) * 0.98
                this.$store.commit('budget/SET_MANUAL_HOUR_CHANGES', { 'factor': factor, 'updateHours': true, 'correctMinimum': false })
                this.$store.commit('budget/SET_PREDICTION_SUMS')
                this.updateBadgeValues()
            } else { // In this case we have changed a commercial variable and we need to recalculate the budget
                let factor = (this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Adjusted / this.$store.state.budget.predictionSums.find(x => x.Variable === variable).Predicted) * 0.98
                this.$store.dispatch('budget/updatePredictionsFactor', { 'factor': factor, 'variable': variable }).then(response => {
                    this.updateBadgeValues()
                })
            }
        },
        increaseWeek () {
            vue.set(this, 'date', new Date(this.date.getTime() + 24 * 60 * 60 * 1000 * 7))
            this.loadBudget()
        },
        decreaseWeek () {
            vue.set(this, 'date', new Date(this.date.getTime() - 24 * 60 * 60 * 1000 * 7))
            this.loadBudget()
        }
    },
    mounted () {
        this.updateBadgeValues()
        if (this.budgetOpen() === false) {
            this.noBudgetsOpen = true
        }
    }
}
</script>

<style lang="scss">
.budget {
    p.budget-info {
        margin-bottom: 0px;
        display: inline;
    }
    .padding-left {
        padding-left: 10px;
    }
    .small-input {
        width: 100px;
    }
    .item {
        margin-top: 10px;
        margin-right: 40px;
    }
    .el-table .highlight-row {
        background: #EBEEF5;
    }
    .table-input-container {
        display: table-cell;
        vertical-align: middle;
        height: 50px;
    }
    .el-input-inner {
        .vertical-align-center {
            margin-bottom: 10px;
        }
    }
    .date-editor-button-plus {
        border-radius: 0;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: none;
    }
    .date-editor-button-minus {
        border-radius: 0;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-right: none;
    }
    .date-editor-button-minus:hover {
        background-color: #fff;
    }
    .date-editor-button-plus:hover, .date-editor-button-plus:active , .date-editor-button-plus:focus, .date-editor-button-minus:hover, .date-editor-button-minus:active , .date-editor-button-minus:focus {
        background-color: #fff;
        border-color: #DCDFE6;
        outline: none !important;
        box-shadow: none !important;
        color: #606266;
    }
    .date-editor-button-plus:hover, .date-editor-button-minus:hover {
        color: #409EFF;
    }
    .el-date-editor {
        .el-input__inner {
            border-radius: 0;
        }
        .el-input__inner:focus, .el-input__inner:hover {
            border-color: #DCDFE6;
        }
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 160px;
    }

}
</style>
